// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media not (min-width:658px){body[data-is-support-mobile-view=true] .faRMpvHW52AcNlbZHc_P{padding-left:16px;padding-right:16px;padding-bottom:10px}}.faRMpvHW52AcNlbZHc_P{padding-left:20px;padding-right:20px;width:100%;max-width:760px;margin:0 auto;padding-bottom:20px;overflow:auto}.faRMpvHW52AcNlbZHc_P.mq4XJdvFYP0DmDRAWFfa{padding-right:76px}.FD17cDRZoe0smdiNznAM{padding-left:12px;padding-right:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messageFieldWrap": `faRMpvHW52AcNlbZHc_P`,
	"intercomWidget": `mq4XJdvFYP0DmDRAWFfa`,
	"wrapTextField": `FD17cDRZoe0smdiNznAM`
};
export default ___CSS_LOADER_EXPORT___;
